module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-1440w.ce4a8e96.webp";